import React, { Component } from 'react';
import { Dialog } from "@material-ui/core";
import {
    NoticeBox,
    ReasonBox,
    Reason,
    BtnBox,
    Cancel,
    RefundOrCancel,
    NoticeContainer,
    Title,
    Text
} from './Notice.style';

import i18n from '../../../../i18n';
class Notice extends Component {
    renderComent = (type) =>{
        if(type === "refund") {
            return (
                <div>
                    <Title><span>{i18n.t("Notice.renderComent.refund.title1_1")}</span>{i18n.t("Notice.renderComent.refund.title1_2")}</Title>
                    <Text>{i18n.t("Notice.renderComent.refund.Text1")}</Text>
                </div>
            
            )
        } else {
            return (
                <div>
                    <Title><span>{i18n.t("Notice.renderComent.refund.title2_1")}</span> {i18n.t("Notice.renderComent.refund.title2_2")}</Title>
                    <Text>{i18n.t("Notice.renderComent.refund.Text2")}</Text>
                </div>
            )
        }
     
    }
    render() {
        return (
            <Dialog maxWidth ={"md"} open={this.props.open} onClose={this.props.closeBtn} stlye={{padding : "20px"}}>
                  <div className="closeBtn" onClick={this.props.closeBtn}>
                    <div className="closeBar1" />
                    <div className="closeBar2" />
                </div>
                <NoticeContainer>
                <NoticeBox>
                    {this.renderComent(this.props.paymentWay)}
                </NoticeBox>
                <ReasonBox>
                    <div><b>{this.props.paymentWay === "refund" ? i18n.t("Notice.refund") :i18n.t("Notice.cancel.sub")} {i18n.t("Notice.reason")}</b></div>
                    <Reason placeholder={`${i18n.t("Notice.placeholder1")} ${this.props.paymentWay === "refund" ? i18n.t("Notice.refund") :i18n.t("Notice.cancel.sub")} ${i18n.t("Notice.placeholder2")}`} onChange ={this.props.onRefundReasonChanged} value={this.props.refundReason}></Reason>
                </ReasonBox>
                <BtnBox>
                    <Cancel onClick ={this.props.closeBtn}>
                        <div>{i18n.t("global.cancel")}</div>
                    </Cancel>
                    <RefundOrCancel active={this.props.active}>
                        {this.props.paymentWay === "refund" ? 
                        <div onClick={this.props.onClickRefund}>{i18n.t("Notice.refund")}</div>
                        :
                        <div onClick={this.props.onClickCancel}>{i18n.t("payment.cancel.subscribe")}</div>
                        }
                    </RefundOrCancel>
                </BtnBox>
                </NoticeContainer>
            </Dialog>
        );
    }
}

export default Notice;